// @flow
import { useParams } from 'react-router-dom';
import React from 'react';

import { LinkRenderer } from '../grid-utils/renderers';
import { NATIVE_INFERENCE_POOL_ID, NATIVE_INFERENCE_POOL_NAME } from '../../../constants';
import { getLinkForNativeInferencePool } from '../../links/utils';

export const NativeInferencePoolNameRenderer = ({ data }) => {
  const { estimateId } = useParams();
  return (
    <LinkRenderer
      pathName={getLinkForNativeInferencePool(estimateId, data[NATIVE_INFERENCE_POOL_ID])}
      text={data[NATIVE_INFERENCE_POOL_NAME]}
    />
  );
};
